import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { HeatmapPremium } from './HeatmapPremium';
// TODO: Define types locally
// import { HeatmapCell } from '../utils/mockData';

interface HeatmapCell {
  day: number;
  hour: number;
  value: number;
}

interface ChartConversaoHorarioProps {
  data: HeatmapCell[];
}

export function ChartConversaoHorario({ data }: ChartConversaoHorarioProps) {
  useLanguage();
  return (
    <HeatmapPremium
      title={translateInterfaceText("Conversão por Horário")}
      subtitle={translateInterfaceText("Conversões por dia e horário")}
      data={data}
      showExport={true}
    />
  );
}
